/* eslint-disable no-undef */
import { init, BrowserTracing, Replay } from '@sentry/react';

init({
  environment: process.env.REACT_APP_SENTRY_ENV,
  dsn: process.env.REACT_APP_SENTRY_DSN,
  enabled: process.env.NODE_ENV !== 'development',
  integrations: [new BrowserTracing(), new Replay()],
  // Performance Monitoring
  tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACE_SAMPLE_RATE), // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: Number(
    process.env.REACT_APP_SENTRY_SESSION_SAMPLE_RATE
  ), // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: Number(
    process.env.REACT_APP_SENTRY_ERROR_SAMPLE_RATE
  ) // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
